// =============================================================================
// AGENT 1 — ARCHITEKT REPOZYTORIUM: GŁÓWNY ROUTER APLIKACJI
// Zarządza przejściami między ekranami (idle → playing → finished).
// =============================================================================

import { useState } from 'react';
import { GameProvider } from './store/gameStore';
import { StartScreen } from './screens/Start/StartScreen';
import { GameScreen } from './screens/Game/GameScreen';
import { ResultsScreen } from './screens/Results/ResultsScreen';

type AppScreen = 'start' | 'game' | 'results';

function AppRouter() {
  const [screen, setScreen] = useState<AppScreen>('start');

  return (
    <>
      {screen === 'start' && <StartScreen onStart={() => setScreen('game')} />}
      {screen === 'game' && <GameScreen onGameEnd={() => setScreen('results')} />}
      {screen === 'results' && <ResultsScreen onRestart={() => setScreen('start')} />}
    </>
  );
}

export default function App() {
  return (
    <GameProvider>
      <AppRouter />
    </GameProvider>
  );
}
